module.exports = __webpack_public_path__ + "152964500a7c0cc2ae2d02c7ddf50c90.jpg";